import React from 'react';
import MkBtn from '../MkBtn';
import MkReviewCard from '../MkReviewCard';
import MkStars from '../MkStars';
import { kmoPlayHref } from '../../../marketing/links';
import { MK_FLAGS } from '../../../marketing/flags';
import { PLAY_FACTS } from '../../../marketing/facts';
import { REVIEWS } from '../../../marketing/reviews';
import { mkTrack } from '../../../marketing/track';

// Wall order (3 columns): Joe (featured, spans 2), Stella / Dylan, Abshir, Amrit / Shakya, Ben, CTA.
// Delays follow the column each card starts in: 0 / 80 / 160.
const WALL = [
  { review: REVIEWS.joe, featured: true, delay: 0 },
  { review: REVIEWS.stella, delay: 160 },
  { review: REVIEWS.dylan, delay: 0 },
  { review: REVIEWS.abshir, delay: 80 },
  { review: REVIEWS.amrit, delay: 160 },
  { review: REVIEWS.shakya, delay: 0 },
  { review: REVIEWS.ben, delay: 80 },
];

// H5 — verbatim, dated, attributed Keep Me Out reviews, linked to the full set on Play.
const HomeReviews = () => (
  <section className="mk-reviews section" id="reviews" aria-labelledby="mk-reviews-title">
    <div className="container">
      <div className="section-inner">
        <div className="mk-head reveal-from-bottom">
          <p className="mk-eyebrow">{`${PLAY_FACTS.ratings} ratings on Google Play`}</p>
          <h2 id="mk-reviews-title" className="mk-h2">
            In their own words
          </h2>
          <p className="mk-lead">Real reviews of Keep Me Out from Google Play, quoted word for word.</p>
          {MK_FLAGS.SHOW_PLAY_RATING && (
            <p className="mk-reviews__meta">
              <MkStars value={Number(PLAY_FACTS.rating)} label={`Rated ${PLAY_FACTS.rating} out of 5`} />
              <span aria-hidden="true">{`Rated ${PLAY_FACTS.rating} out of 5`}</span>
              <span className="mk-reviews__meta-sep" aria-hidden="true">
                ·
              </span>
              <span>{`Default Google Play rating, ${PLAY_FACTS.asOfLong}`}</span>
            </p>
          )}
        </div>
        <ul className="list-reset mk-reviews__wall">
          {WALL.map((w) => (
            <li
              key={w.review.key}
              className={`mk-reviews__item${w.featured ? ' mk-reviews__item--featured' : ''} reveal-from-bottom`}
              data-reveal-container=".mk-reviews__wall"
              data-reveal-delay={w.delay}
            >
              <MkReviewCard review={w.review} variant={w.featured ? 'featured' : undefined} />
            </li>
          ))}
          <li
            className="mk-reviews__item mk-reviews__item--cta reveal-from-bottom"
            data-reveal-container=".mk-reviews__wall"
            data-reveal-delay="160"
          >
            <div className="mk-card mk-reviews__cta">
              <h3 className="mk-h3">Read every review, good and bad.</h3>
              <MkBtn
                variant="ghost"
                href={kmoPlayHref('home_reviews')}
                onClick={() => mkTrack('outbound_click', 'play_reviews:home_reviews')}
              >
                Read all reviews on Google Play
              </MkBtn>
              <p className="mk-micro">We reply to reviews there.</p>
            </div>
          </li>
        </ul>
        <p className="mk-micro mk-reviews__note">
          Hand-picked from public Google Play reviews of Keep Me Out. Trimmed quotes are marked with "…". Spelling is
          the reviewer's own.
        </p>
      </div>
    </div>
  </section>
);

export default HomeReviews;
